const config = {
  AppName: "Restaurant Critic",
};

export default config;